import { forwardRef, type ButtonHTMLAttributes, type ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface IconBtnProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  icon: ReactNode;
  active?: boolean;
  size?: number;
  label?: string;
}

export const IconBtn = forwardRef<HTMLButtonElement, IconBtnProps>(
  ({ icon, active, size = 28, label, className, type, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        type={type ?? 'button'}
        title={label}
        aria-label={label}
        style={{ width: size, height: size }}
        className={cn(
          'grid place-items-center rounded-md border border-transparent cursor-pointer transition-colors',
          active
            ? 'bg-warm-bg text-foreground'
            : 'bg-transparent text-muted-foreground hover:bg-warm-bg hover:text-foreground',
          className,
        )}
        {...rest}
      >
        {icon}
      </button>
    );
  },
);
IconBtn.displayName = 'IconBtn';
